import * as Material  from '@material-ui/core';
import * as Bootstrap from 'react-bootstrap';
import * as ReactTabs from 'react-tabs';
import styled from 'styled-components';
import theme from 'theme';

export const Avatar = styled(Material.Avatar)`
    margin: 8px;
    background-color: ${theme.palette.primary.main};
`; 

export const Container = styled(Material.Container)`
  padding-top: ${theme.spacing(8)}px;
`;

export const LoginBox = styled(Bootstrap.Col)`
  border: 1px solid ${theme.palette.primary.main};
  padding: ${theme.spacing(8)}px;
  border-radius: 25px;
`;

export const LoginSubTitle = styled.h4`
  margin:  0 0 23px 0;
  font-weight: normal;
`;

export const LoginTitle = styled.h2`
  font-weight: bold;
  margin:  0 0 63px 0;
`

export const LoginTabList = styled(ReactTabs.TabList)`
  padding: 0;
`;

export const LoginTab = styled(ReactTabs.Tab)`
  display: inline-block;
  padding: 10px 71px 10px 0;
  text-align: left;

  &:last-child {
    padding-right: 0;
  }
`;

export const LoginTabLabel = styled.span`
  padding-bottom: 10px;
  &:hover {
    border-bottom: 1px solid ${theme.palette.primary.main};
  }
`;

export const LoginTabPanel = styled(ReactTabs.TabPanel)`
  margin-top: 17px;
`;
